export const EQUIPMENT_SKU_CONFLICT_MESSAGE = 'Já existe um equipamento atrelado a esse SKU, '
  + 'para cadastrar é preciso desvincular primeiro';

export const EQUIPMENT_DUPLICATE_BRAND_MODEL_MESSAGE = 'Não foi possível salvar as alterações. '
  + 'Já existe um cadastro ativo para esta combinação de marca e modelo. '
  + 'Inative o outro equipamento existente antes de continuar.';

export function resolveEquipmentConflictMessage(error: unknown): string | undefined {
  const response = (error as { response?: { data?: { detail?: unknown }; status?: number } })?.response;

  if (response?.status !== 409) {
    return undefined;
  }

  const detail = response.data?.detail;
  const isSkuConflict = typeof detail === 'string'
    && detail.toLowerCase().includes('sku already exists');

  if (isSkuConflict) {
    return EQUIPMENT_SKU_CONFLICT_MESSAGE;
  }

  return EQUIPMENT_DUPLICATE_BRAND_MODEL_MESSAGE;
}
